(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["skintypes-expert"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('skintypes-expert')) {
    customElements.define('skintypes-expert', class extends HTMLElement {
      connectedCallback() {
        if (this._controller) return;
        this._controller = new AbortController();
        const opts = { signal: this._controller.signal };
        this.classList.add('ske--enhanced');
        this.addEventListener('change', event => {
          if (!event.target.matches('[data-variant]')) return;
          const option = event.target.selectedOptions[0];
          const row = event.target.closest('[data-row]');
          const price = row.querySelector('.ske__prices [data-price]');
          const compare = row.querySelector('.ske__prices [data-compare]');
          if (price) price.textContent = option.dataset.price;
          if (compare) { compare.textContent = option.dataset.compare || ''; compare.hidden = !option.dataset.compare; }
          const picker = row.querySelector('[data-picker]');
          if (picker) {
            picker.querySelector('[data-choice-label]').textContent = option.textContent;
            picker.querySelectorAll('[data-choice]').forEach(choice => choice.setAttribute('aria-pressed', String(choice.dataset.choice === option.value)));
          }
          const tip = [...this.querySelectorAll('[data-tip]')].find(el => el.dataset.tip === row.dataset.block);
          if (tip?.querySelector('[data-tip-price]')) tip.querySelector('[data-tip-price]').textContent = option.dataset.price;
          const button = row.querySelector('[data-add]');
          button.disabled = option.dataset.available !== 'true';
          row.querySelector('[data-status]').textContent = '';
        }, opts);
        this.addEventListener('pointerover', event => {
          const marker = event.target.closest('[data-marker]');
          if (marker && event.pointerType !== 'touch') this.showTip(marker);
          const row = event.target.closest('[data-row]');
          if (row) this.highlight(row.dataset.block);
        }, opts);
        this.addEventListener('focusin', event => {
          const marker = event.target.closest('[data-marker]');
          if (marker) this.showTip(marker);
          const row = event.target.closest('[data-row]');
          if (row) this.highlight(row.dataset.block);
        }, opts);
        this.addEventListener('click', event => {
          const choice = event.target.closest('[data-choice]');
          if (choice) {
            const form = choice.closest('form');
            const select = form.querySelector('[data-variant]');
            if (select.disabled || choice.disabled) return;
            select.value = choice.dataset.choice;
            select.dispatchEvent(new Event('change', { bubbles: true }));
            const picker = choice.closest('details');
            picker.open = false;
            picker.querySelector('summary').focus();
            return;
          }
          const marker = event.target.closest('[data-marker]');
          if (marker) {
            if (this._pinned === marker.dataset.marker) this.hideTips();
            else { this.showTip(marker); this._pinned = marker.dataset.marker; }
            return;
          }
          const rowLink = event.target.closest('[data-show-row]');
          if (!rowLink) return;
          event.preventDefault();
          const row = [...this.querySelectorAll('[data-row]')].find(el => el.dataset.block === rowLink.dataset.showRow);
          if (!row) return;
          this.hideTips();
          this.highlight(row.dataset.block);
          row.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
          row.querySelector('a')?.focus({ preventScroll: true });
        }, opts);
        const markers = this.querySelector('.ske__markers');
        markers?.addEventListener('pointerleave', () => { if (!this._pinned && !markers.contains(document.activeElement)) this.hideTips(); }, opts);
        markers?.addEventListener('focusout', event => { if (!markers.contains(event.relatedTarget) && !this._pinned) this.hideTips(); }, opts);
        document.addEventListener('click', event => {
          if (!markers?.contains(event.target)) this.hideTips();
          this.querySelectorAll('[data-picker][open]').forEach(picker => { if (!picker.contains(event.target)) picker.open = false; });
        }, opts);
        this.addEventListener('keydown', event => {
          if (event.key !== 'Escape') return;
          const activeMarker = this.querySelector('[data-marker][aria-expanded="true"]');
          if (activeMarker) { activeMarker.focus(); this.hideTips(); }
          this.querySelectorAll('[data-picker][open]').forEach(picker => { picker.open = false; picker.querySelector('summary').focus(); });
        }, opts);
        window.addEventListener('resize', () => {
          const marker = this.querySelector('[data-marker][aria-expanded="true"]');
          if (marker) this.positionTip(marker);
        }, opts);
        this.addEventListener('submit', event => {
          if (!event.target.matches('.ske__form')) return;
          event.preventDefault();
          this.addProduct(event.target);
        }, opts);
      }
      disconnectedCallback() { this._controller?.abort(); this._controller = null; }
      hideTips() {
        this._pinned = null;
        this.querySelectorAll('[data-tip]').forEach(tip => tip.hidden = true);
        this.querySelectorAll('[data-marker]').forEach(marker => marker.setAttribute('aria-expanded', 'false'));
      }
      showTip(marker) {
        if (this._pinned && this._pinned !== marker.dataset.marker) this._pinned = null;
        this.querySelectorAll('[data-tip]').forEach(tip => tip.hidden = tip.dataset.tip !== marker.dataset.marker);
        this.querySelectorAll('[data-marker]').forEach(el => el.setAttribute('aria-expanded', String(el === marker)));
        this.highlight(marker.dataset.marker);
        this.positionTip(marker);
      }
      positionTip(marker) {
        const tip = [...this.querySelectorAll('[data-tip]')].find(el => el.dataset.tip === marker.dataset.marker);
        if (!tip) return;
        const nav = marker.parentElement;
        const center = marker.offsetLeft + marker.offsetWidth / 2;
        const left = Math.max(0, Math.min(center - tip.offsetWidth / 2, nav.clientWidth - tip.offsetWidth));
        tip.style.left = left + 'px';
        tip.style.setProperty('--ske-arrow', Math.max(16, Math.min(center - left, tip.offsetWidth - 16)) + 'px');
        const photo = nav.closest('.ske__photo').getBoundingClientRect();
        const navRect = nav.getBoundingClientRect();
        const minTop = photo.top + 8 - navRect.top;
        const maxTop = photo.bottom - 8 - navRect.top - tip.offsetHeight;
        let top = marker.offsetTop - tip.offsetHeight - 12;
        const below = marker.offsetTop + marker.offsetHeight + 12;
        const useBelow = top < minTop && below <= maxTop;
        if (useBelow) top = below;
        tip.classList.toggle('is-below', useBelow);
        tip.style.bottom = 'auto';
        tip.style.top = Math.max(minTop, Math.min(top, maxTop)) + 'px';
      }
      highlight(id) {
        this.querySelectorAll('[data-row]').forEach(row => row.classList.toggle('is-active', row.dataset.block === id));
        this.querySelectorAll('[data-marker]').forEach(marker => {
          marker.classList.toggle('is-active', marker.dataset.marker === id);
          if (marker.dataset.marker === id) marker.setAttribute('aria-current', 'true');
          else marker.removeAttribute('aria-current');
        });
      }
      async addProduct(form) {
        // Serialize requests across section instances; never retry an uncertain POST.
        const owner = this.constructor;
        const status = form.querySelector('[data-status]');
        if (owner.busy) { status.textContent = 'Palaukite, kol bus pridėtas ankstesnis produktas.'; return; }
        if (!form.checkValidity()) { form.reportValidity(); return; }
        const button = form.querySelector('[data-add]');
        if (button.disabled) return;
        const label = button.querySelector('[data-add-label]');
        const originalLabel = label.textContent;
        const selector = form.querySelector('select');
        const body = new FormData(form);
        body.append('sections', 'mini-cart');
        body.append('sections_url', location.pathname);
        owner.busy = true;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        if (selector) selector.disabled = true;
        label.textContent = 'Pridedama…';
        status.textContent = '';
        status.removeAttribute('data-error');
        let added = false;
        try {
          const response = await fetch(this.dataset.addUrl + '.js', { method: 'POST', credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }, body });
          const result = await response.json();
          if (!response.ok) {
            status.setAttribute('data-error', '');
            status.textContent = typeof result.description === 'string' ? result.description : 'Produkto pridėti nepavyko. Patikrinkite pasirinkto varianto prieinamumą.';
            return;
          }
          added = true;
          status.textContent = 'Produktas pridėtas į krepšelį.';
          const theme = window.themeVariables;
          if (theme?.settings?.cartType === 'page') { location.assign(this.dataset.cartUrl); return; }
          // Focal: same event payloads as the store's native ProductForm.
          if (theme && customElements.get('cart-count')) {
            const cartResponse = await fetch(this.dataset.cartUrl + '.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } });
            if (!cartResponse.ok) throw new Error('cart-refresh');
            const cart = await cartResponse.json();
            document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart } }));
            const mini = result.sections?.['mini-cart'];
            if (typeof mini === 'string' && mini.includes('<cart-drawer')) cart.sections = result.sections;
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart, openMiniCart: theme.settings.cartType === 'drawer' } }));
            form.dispatchEvent(new CustomEvent('variant:added', { bubbles: true, detail: { variant: result.items ? result.items[0] : result } }));
          } else {
            // Unknown themes get a fresh cart page instead of a stale cart count.
            location.assign(this.dataset.cartUrl);
          }
        } catch (error) {
          status.setAttribute('data-error', '');
          status.textContent = added ? 'Produktas pridėtas. Atnaujinkite krepšelį paspaudę „Peržiūrėti krepšelį“.' : 'Nepavyko patvirtinti rezultato. Prieš bandydami dar kartą patikrinkite krepšelį.';
        } finally {
          owner.busy = false;
          button.disabled = false;
          button.removeAttribute('aria-busy');
          if (selector) selector.disabled = false;
          label.textContent = originalLabel;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
